import * as React from 'react';
import { CIRCLE_VERTICAL_ITEM, } from '../../../types/templates/widgets/items/ISkyfireVerticalItem';
import { bindHandler, buildTags, preventDefault } from '../../../utils';
import { useObserver } from '../../../utils/ObserverHooks';
import ContextMenuButton from '../../ContextMenuButton';
import Button from './Button';
export var VerticalItemSize;
(function (VerticalItemSize) {
    VerticalItemSize[VerticalItemSize["Small"] = 0] = "Small";
    VerticalItemSize[VerticalItemSize["Medium"] = 1] = "Medium";
})(VerticalItemSize || (VerticalItemSize = {}));
const verticalItemSizeProperties = {
    [VerticalItemSize.Small]: 'small',
    [VerticalItemSize.Medium]: 'medium',
};
/**
 * Calculates vertical item size based on internal content.
 * @param item vertical item
 */
export function getItemSize(item) {
    return item.secondaryText ? VerticalItemSize.Medium : VerticalItemSize.Small;
}
export default function VerticalItem(props) {
    var _a, _b, _c;
    const { image, primaryLink, secondaryText, isDisabled, hintIconName, actionIconName, secondaryLink, actionIconLink, iconButton, tags, leftButton, primaryText, contextMenu, } = props.data;
    const { position } = props;
    const bindHandlerHelper = (fn) => bindHandler(props.handleSelected, this, fn);
    const primaryTextElement = useObserver(primaryText);
    const iconButtonElement = useObserver(iconButton);
    return (React.createElement("music-vertical-item", { key: (primaryTextElement.text || primaryText) + (secondaryText || ''), style: props.style, disabled: isDisabled, "image-src": image, onClick: preventDefault, "primary-text": `${position ? position + '. ' : ''}${primaryTextElement.text || primaryText}`, "primary-href": primaryLink.deeplink, kind: props.data.interface === CIRCLE_VERTICAL_ITEM ? 'circle' : '', parentSize: verticalItemSizeProperties[props.parentSize || VerticalItemSize.Small], "hint-icon-name": hintIconName, "icon-name": ((_a = iconButtonElement) === null || _a === void 0 ? void 0 : _a.icon) || actionIconName, "show-action-button": !!iconButtonElement || !!actionIconLink, onmusicPrimaryTextActivate: bindHandlerHelper(primaryLink.onItemSelected), "secondary-text": secondaryText, "secondary-href": (_b = secondaryLink) === null || _b === void 0 ? void 0 : _b.deeplink, onmusicSecondaryTextActivate: bindHandlerHelper(secondaryLink ? secondaryLink.onItemSelected : []), onmusicActionButtonActivate: bindHandlerHelper(((_c = iconButtonElement) === null || _c === void 0 ? void 0 : _c.onItemSelected) ||
            (actionIconLink ? actionIconLink.onItemSelected : [])) },
        buildTags(tags, isDisabled),
        leftButton && React.createElement(Button, { data: leftButton, handleSelected: props.handleSelected, slot: "leftButton" }),
        contextMenu &&
            React.createElement(ContextMenuButton, { options: contextMenu.options, disabled: contextMenu.disabled, slot: 'rightButton', variant: 'primary', iconName: 'more', onItemSelected: contextMenu.onItemSelected })));
}
;
